// extracted by mini-css-extract-plugin
module.exports = {"root":"Tab-root-1w4CH","button":"Tab-button-1-aSC","primary":"Tab-primary-3ev1e","default":"Tab-default-3mMo1","active":"Tab-active-ta5n5","secondary":"Tab-secondary-yzzUS"};